/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "ddoe",
      "-2": "echdoe",
      "0": "heddiw",
      "1": "yfory",
      "2": "drennydd",
      "future": {
        "few": "ymhen {0} diwrnod",
        "many": "ymhen {0} diwrnod",
        "one": "ymhen diwrnod",
        "other": "ymhen {0} diwrnod",
        "two": "ymhen deuddydd",
        "zero": "ymhen {0} diwrnod"
      },
      "past": {
        "few": "{0} diwrnod yn ôl",
        "many": "{0} diwrnod yn ôl",
        "one": "{0} diwrnod yn ôl",
        "other": "{0} diwrnod yn ôl",
        "two": "{0} ddiwrnod yn ôl",
        "zero": "{0} diwrnod yn ôl"
      }
    },
    "day-narrow": {
      "-1": "ddoe",
      "-2": "echdoe",
      "0": "heddiw",
      "1": "yfory",
      "2": "drennydd",
      "future": {
        "few": "ymhen {0} diwrnod",
        "many": "ymhen {0} diwrnod",
        "one": "ymhen {0} diwrnod",
        "other": "ymhen {0} diwrnod",
        "two": "ymhen {0} diwrnod",
        "zero": "ymhen {0} diwrnod"
      },
      "past": {
        "few": "{0} diwrnod yn ôl",
        "many": "{0} diwrnod yn ôl",
        "one": "{0} diwrnod yn ôl",
        "other": "{0} diwrnod yn ôl",
        "two": "{0} ddiwrnod yn ôl",
        "zero": "{0} diwrnod yn ôl"
      }
    },
    "day-short": {
      "-1": "ddoe",
      "-2": "echdoe",
      "0": "heddiw",
      "1": "yfory",
      "2": "drennydd",
      "future": {
        "few": "ymhen {0} diwrnod",
        "many": "ymhen {0} diwrnod",
        "one": "ymhen diwrnod",
        "other": "ymhen {0} diwrnod",
        "two": "ymhen deuddydd",
        "zero": "ymhen {0} diwrnod"
      },
      "past": {
        "few": "{0} diwrnod yn ôl",
        "many": "{0} diwrnod yn ôl",
        "one": "{0} diwrnod yn ôl",
        "other": "{0} diwrnod yn ôl",
        "two": "{0} ddiwrnod yn ôl",
        "zero": "{0} diwrnod yn ôl"
      }
    },
    "hour": {
      "0": "yr awr hon",
      "future": {
        "few": "ymhen {0} awr",
        "many": "ymhen {0} awr",
        "one": "ymhen awr",
        "other": "ymhen {0} awr",
        "two": "ymhen {0} awr",
        "zero": "ymhen {0} awr"
      },
      "past": {
        "few": "{0} awr yn ôl",
        "many": "{0} awr yn ôl",
        "one": "{0} awr yn ôl",
        "other": "{0} awr yn ôl",
        "two": "{0} awr yn ôl",
        "zero": "{0} awr yn ôl"
      }
    },
    "hour-narrow": {
      "0": "yr awr hon",
      "future": {
        "few": "ymhen {0} awr",
        "many": "ymhen {0} awr",
        "one": "ymhen {0} awr",
        "other": "ymhen {0} awr",
        "two": "ymhen {0} awr",
        "zero": "ymhen {0} awr"
      },
      "past": {
        "few": "{0} awr yn ôl",
        "many": "{0} awr yn ôl",
        "one": "{0} awr yn ôl",
        "other": "{0} awr yn ôl",
        "two": "{0} awr yn ôl",
        "zero": "{0} awr yn ôl"
      }
    },
    "hour-short": {
      "0": "yr awr hon",
      "future": {
        "few": "ymhen {0} awr",
        "many": "ymhen {0} awr",
        "one": "ymhen awr",
        "other": "ymhen {0} awr",
        "two": "ymhen {0} awr",
        "zero": "ymhen {0} awr"
      },
      "past": {
        "few": "{0} awr yn ôl",
        "many": "{0} awr yn ôl",
        "one": "awr yn ôl",
        "other": "{0} awr yn ôl",
        "two": "{0} awr yn ôl",
        "zero": "{0} awr yn ôl"
      }
    },
    "minute": {
      "0": "y funud hon",
      "future": {
        "few": "ymhen {0} munud",
        "many": "ymhen {0} munud",
        "one": "ymhen {0} munud",
        "other": "ymhen {0} munud",
        "two": "ymhen {0} munud",
        "zero": "ymhen {0} munud"
      },
      "past": {
        "few": "{0} munud yn ôl",
        "many": "{0} munud yn ôl",
        "one": "{0} munud yn ôl",
        "other": "{0} munud yn ôl",
        "two": "{0} munud yn ôl",
        "zero": "{0} munud yn ôl"
      }
    },
    "minute-narrow": {
      "0": "y funud hon",
      "future": {
        "few": "ymhen {0} munud",
        "many": "ymhen {0} munud",
        "one": "ymhen {0} mun.",
        "other": "ymhen {0} mun.",
        "two": "ymhen {0} mun.",
        "zero": "ymhen {0} munud"
      },
      "past": {
        "few": "{0} mun. yn ôl",
        "many": "{0} munud yn ôl",
        "one": "{0} mun. yn ôl",
        "other": "{0} mun. yn ôl",
        "two": "{0} mun. yn ôl",
        "zero": "{0} munud yn ôl"
      }
    },
    "minute-short": {
      "0": "y funud hon",
      "future": {
        "few": "ymhen {0} munud",
        "many": "ymhen {0} munud",
        "one": "ymhen {0} mun.",
        "other": "ymhen {0} mun.",
        "two": "ymhen {0} fun.",
        "zero": "ymhen {0} munud"
      },
      "past": {
        "few": "{0} munud yn ôl",
        "many": "{0} munud yn ôl",
        "one": "{0} mun. yn ôl",
        "other": "{0} mun. yn ôl",
        "two": "{0} funud yn ôl",
        "zero": "{0} munud yn ôl"
      }
    },
    "month": {
      "-1": "mis diwethaf",
      "0": "y mis hwn",
      "1": "mis nesaf",
      "future": {
        "few": "ymhen {0} mis",
        "many": "ymhen {0} mis",
        "one": "ymhen mis",
        "other": "ymhen {0} mis",
        "two": "ymhen deufis",
        "zero": "ymhen {0} mis"
      },
      "past": {
        "few": "{0} mis yn ôl",
        "many": "{0} mis yn ôl",
        "one": "{0} mis yn ôl",
        "other": "{0} mis yn ôl",
        "two": "{0} fis yn ôl",
        "zero": "{0} mis yn ôl"
      }
    },
    "month-narrow": {
      "-1": "mis diwethaf",
      "0": "y mis hwn",
      "1": "mis nesaf",
      "future": {
        "few": "ymhen {0} mis",
        "many": "ymhen {0} mis",
        "one": "ymhen mis",
        "other": "ymhen {0} mis",
        "two": "ymhen deufis",
        "zero": "ymhen {0} mis"
      },
      "past": {
        "few": "{0} mis yn ôl",
        "many": "{0} mis yn ôl",
        "one": "{0} mis yn ôl",
        "other": "{0} mis yn ôl",
        "two": "{0} fis yn ôl",
        "zero": "{0} mis yn ôl"
      }
    },
    "month-short": {
      "-1": "mis diwethaf",
      "0": "y mis hwn",
      "1": "mis nesaf",
      "future": {
        "few": "ymhen {0} mis",
        "many": "ymhen {0} mis",
        "one": "ymhen mis",
        "other": "ymhen {0} mis",
        "two": "ymhen deufis",
        "zero": "ymhen {0} mis"
      },
      "past": {
        "few": "{0} mis yn ôl",
        "many": "{0} mis yn ôl",
        "one": "{0} mis yn ôl",
        "other": "{0} mis yn ôl",
        "two": "deufis yn ôl",
        "zero": "{0} mis yn ôl"
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "chwarter olaf",
      "0": "chwarter hwn",
      "1": "chwarter nesaf",
      "future": {
        "few": "ymhen {0} chwarter",
        "many": "ymhen {0} chwarter",
        "one": "ymhen {0} chwarter",
        "other": "ymhen {0} chwarter",
        "two": "ymhen {0} chwarter",
        "zero": "ymhen {0} chwarter"
      },
      "past": {
        "few": "{0} chwarter yn ôl",
        "many": "{0} chwarter yn ôl",
        "one": "{0} chwarter yn ôl",
        "other": "{0} o chwarteri yn ôl",
        "two": "{0} chwarter yn ôl",
        "zero": "{0} o chwarteri yn ôl"
      }
    },
    "quarter-narrow": {
      "-1": "chwarter olaf",
      "0": "chwarter hwn",
      "1": "chwarter nesaf",
      "future": {
        "few": "ymhen {0} chwarter",
        "many": "ymhen {0} chwarter",
        "one": "ymhen {0} chw.",
        "other": "ymhen {0} chw.",
        "two": "ymhen {0} chwarter",
        "zero": "ymhen {0} chwarter"
      },
      "past": {
        "few": "{0} chwarter yn ôl",
        "many": "{0} chwarter yn ôl",
        "one": "{0} chw. yn ôl",
        "other": "{0} chw. yn ôl",
        "two": "{0} chwarter yn ôl",
        "zero": "{0} o chwarteri yn ôl"
      }
    },
    "quarter-short": {
      "-1": "chwarter olaf",
      "0": "chwarter hwn",
      "1": "chwarter nesaf",
      "future": {
        "few": "ymhen {0} chwarter",
        "many": "ymhen {0} chwarter",
        "one": "ymhen {0} chw.",
        "other": "ymhen {0} chw.",
        "two": "ymhen {0} chwarter",
        "zero": "ymhen {0} chwarter"
      },
      "past": {
        "few": "{0} chwarter yn ôl",
        "many": "{0} chwarter yn ôl",
        "one": "{0} chw. yn ôl",
        "other": "{0} chw. yn ôl",
        "two": "{0} chwarter yn ôl",
        "zero": "{0} o chwarteri yn ôl"
      }
    },
    "second": {
      "0": "nawr",
      "future": {
        "few": "ymhen {0} eiliad",
        "many": "ymhen {0} eiliad",
        "one": "ymhen {0} eiliad",
        "other": "ymhen {0} eiliad",
        "two": "ymhen {0} eiliad",
        "zero": "ymhen {0} eiliad"
      },
      "past": {
        "few": "{0} eiliad yn ôl",
        "many": "{0} eiliad yn ôl",
        "one": "{0} eiliad yn ôl",
        "other": "{0} eiliad yn ôl",
        "two": "{0} eiliad yn ôl",
        "zero": "{0} eiliad yn ôl"
      }
    },
    "second-narrow": {
      "0": "nawr",
      "future": {
        "few": "ymhen {0} eiliad",
        "many": "ymhen {0} eiliad",
        "one": "ymhen {0} eiliad",
        "other": "ymhen {0} eiliad",
        "two": "ymhen {0} eiliad",
        "zero": "ymhen {0} eiliad"
      },
      "past": {
        "few": "{0} eiliad yn ôl",
        "many": "{0} eiliad yn ôl",
        "one": "{0} eiliad yn ôl",
        "other": "{0} eiliad yn ôl",
        "two": "{0} eiliad yn ôl",
        "zero": "{0} eiliad yn ôl"
      }
    },
    "second-short": {
      "0": "nawr",
      "future": {
        "few": "ymhen {0} eiliad",
        "many": "ymhen {0} eiliad",
        "one": "ymhen {0} eil.",
        "other": "ymhen {0} eil.",
        "two": "ymhen {0} eiliad",
        "zero": "ymhen {0} eiliad"
      },
      "past": {
        "few": "{0} eiliad yn ôl",
        "many": "{0} eiliad yn ôl",
        "one": "{0} eil. yn ôl",
        "other": "{0} eil. yn ôl",
        "two": "{0} eiliad yn ôl",
        "zero": "{0} eiliad yn ôl"
      }
    },
    "week": {
      "-1": "wythnos ddiwethaf",
      "0": "yr wythnos hon",
      "1": "wythnos nesaf",
      "future": {
        "few": "ymhen {0} wythnos",
        "many": "ymhen {0} wythnos",
        "one": "ymhen wythnos",
        "other": "ymhen {0} wythnos",
        "two": "ymhen pythefnos",
        "zero": "ymhen {0} wythnos"
      },
      "past": {
        "few": "{0} wythnos yn ôl",
        "many": "{0} wythnos yn ôl",
        "one": "{0} wythnos yn ôl",
        "other": "{0} wythnos yn ôl",
        "two": "{0} wythnos yn ôl",
        "zero": "{0} wythnos yn ôl"
      }
    },
    "week-narrow": {
      "-1": "ws. ddiwethaf",
      "0": "yr ws. hon",
      "1": "ws. nesaf",
      "future": {
        "few": "ymhen {0} wythnos",
        "many": "ymhen {0} wythnos",
        "one": "ymhen {0} ws.",
        "other": "ymhen {0} ws.",
        "two": "ymhen {0} wythnos",
        "zero": "ymhen {0} wythnos"
      },
      "past": {
        "few": "{0} wythnos yn ôl",
        "many": "{0} wythnos yn ôl",
        "one": "{0} ws. yn ôl",
        "other": "{0} ws. yn ôl",
        "two": "pythefnos yn ôl",
        "zero": "{0} wythnos yn ôl"
      }
    },
    "week-short": {
      "-1": "ws. ddiwethaf",
      "0": "yr ws. hon",
      "1": "ws. nesaf",
      "future": {
        "few": "ymhen {0} wythnos",
        "many": "ymhen {0} wythnos",
        "one": "ymhen ws.",
        "other": "ymhen {0} ws.",
        "two": "ymhen pythefnos",
        "zero": "ymhen {0} wythnos"
      },
      "past": {
        "few": "{0} wythnos yn ôl",
        "many": "{0} wythnos yn ôl",
        "one": "{0} ws. yn ôl",
        "other": "{0} ws yn ôl.",
        "two": "pythefnos yn ôl",
        "zero": "{0} wythnos yn ôl"
      }
    },
    "year": {
      "-1": "llynedd",
      "0": "eleni",
      "1": "blwyddyn nesaf",
      "future": {
        "few": "ymhen {0} blynedd",
        "many": "ymhen {0} blynedd",
        "one": "ymhen blwyddyn",
        "other": "ymhen {0} mlynedd",
        "two": "ymhen {0} flynedd",
        "zero": "ymhen {0} mlynedd"
      },
      "past": {
        "few": "{0} blynedd yn ôl",
        "many": "{0} blynedd yn ôl",
        "one": "blwyddyn yn ôl",
        "other": "{0} o flynyddoedd yn ôl",
        "two": "{0} flynedd yn ôl",
        "zero": "{0} o flynyddoedd yn ôl"
      }
    },
    "year-narrow": {
      "-1": "llynedd",
      "0": "eleni",
      "1": "bl. nesaf",
      "future": {
        "few": "ymhen {0} blynedd",
        "many": "ymhen {0} blynedd",
        "one": "ymhen bl.",
        "other": "ymhen {0} mlynedd",
        "two": "ymhen {0} flynedd",
        "zero": "ymhen {0} mlynedd"
      },
      "past": {
        "few": "{0} blynedd yn ôl",
        "many": "{0} blynedd yn ôl",
        "one": "blwyddyn yn ôl",
        "other": "{0} bl. yn ôl",
        "two": "{0} flynedd yn ôl",
        "zero": "{0} o flynyddoedd yn ôl"
      }
    },
    "year-short": {
      "-1": "llynedd",
      "0": "eleni",
      "1": "blwyddyn nesaf",
      "future": {
        "few": "ymhen {0} blynedd",
        "many": "ymhen {0} blynedd",
        "one": "ymhen blwyddyn",
        "other": "ymhen {0} mlynedd",
        "two": "ymhen {0} flynedd",
        "zero": "ymhen {0} mlynedd"
      },
      "past": {
        "few": "{0} blynedd yn ôl",
        "many": "{0} blynedd yn ôl",
        "one": "{0} bl. yn ôl",
        "other": "{0} bl. yn ôl",
        "two": "{0} flynedd yn ôl",
        "zero": "{0} o flynyddoedd yn ôl"
      }
    }
  },
  "locale": "cy"
})
}
